import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import ReactDOM from 'react-dom';

export const MyMProgress = () => {
  return ReactDOM.createPortal(
    <Box sx={{
      zIndex: 2147483647,
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.3)"
    }}>
      <CircularProgress />
    </Box>
    , document.getElementById('root')
  )
}